import { Tab, TabGroup, TabList, TabPanel } from "@headlessui/react";
import { FilesIcon, Home } from "lucide-react";
import type TabView from "../../types/ui/TabView";
import TicketOverview from "./TicketOverview";
import FilesList from "../files/FilesList";
import type { RecordId } from "@repo/types/ui/tables";
import { EntityType } from "@repo/types/enums";

export interface ViewTicketProps {
  ticketId: RecordId;
}

export default function ViewTicket({ ticketId }: ViewTicketProps) {
  const ticketViewTabs: TabView[] = [
    {
      Id: 1,
      Name: "Ticket Overview",
      Icon: <Home size={16} />,
      Element: <TicketOverview ticketId={ticketId} />,
    },
    { Id: 2, Name: "Updates", Element: <div /> },
    {
      Id: 3,
      Name: "Files",
      Icon: <FilesIcon size={16} />,
      Element: <FilesList recordId={ticketId} entityType={EntityType.Ticket} />,
    },
  ];

  return (
    <TabGroup>
      <TabList className="flex border-b border-gray-200 px-4">
        {ticketViewTabs.map((tab) => (
          <Tab
            key={tab.Id}
            className={`relative pr-4 pl-4 pt-2 pb-3 flex rounded-t-xs text-sm outline-none transition hover:bg-gray-200 hover:cursor-pointer`}
          >
            {({ selected }) => (
              <div className="flex items-center gap-2">
                {tab.Icon ?? tab.Icon}
                {tab.Name}
                {selected && (
                  <span className="absolute bottom-0 left-0 w-full h-0.5 bg-sky-600 rounded-full transition" />
                )}
              </div>
            )}
          </Tab>
        ))}
      </TabList>

      {ticketViewTabs.map((tab) => (
        <TabPanel key={tab.Id} className="mt-4">
          {tab.Element}
        </TabPanel>
      ))}
    </TabGroup>
  );
}
